import { render } from "./ListePatient.vue?vue&type=template&id=3ebdd5c8&scoped=true"
import script from "./ListePatient.vue?vue&type=script&lang=js"
export * from "./ListePatient.vue?vue&type=script&lang=js"

import "./ListePatient.vue?vue&type=style&index=0&id=3ebdd5c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebdd5c8"]])

export default __exports__